import React from 'react';
import { motion, useScroll, useSpring, useReducedMotion } from 'framer-motion';

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const reduce = useReducedMotion();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.3 });

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-[3px] origin-left z-[60] pointer-events-none bg-gradient-to-r from-cyan-400 via-fuchsia-500 to-yellow-400"
      style={{ scaleX: reduce ? scrollYProgress : scaleX }}
      data-testid="scroll-progress"
    />
  );
};
